var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { pxToRem } from '../../utils';
var underlinedItem = function (color) { return ({
    paddingBottom: 0,
    borderBottom: "solid " + pxToRem(4) + " " + color,
    transition: 'color .1s ease',
}); };
var getActionStyles = function (_a) {
    var _b = _a.props, primary = _b.primary, underlined = _b.underlined, iconOnly = _b.iconOnly, isFromKeyboard = _b.isFromKeyboard, v = _a.variables, color = _a.color;
    return underlined || iconOnly
        ? {
            color: color,
            background: v.backgroundColor,
        }
        : primary
            ? {
                color: v.primaryActiveColor,
                background: v.primaryActiveBackgroundColor,
            }
            : {
                color: color,
                background: v.activeBackgroundColor,
            };
};
var getFocusedStyles = function (_a) {
    var props = _a.props, v = _a.variables, color = _a.color;
    var primary = props.primary, underlined = props.underlined, iconOnly = props.iconOnly, isFromKeyboard = props.isFromKeyboard, active = props.active;
    if (active && !underlined)
        return {};
    return __assign({}, ((underlined && !isFromKeyboard) || iconOnly
        ? {
            color: color,
            background: v.backgroundColor,
        }
        : primary
            ? {
                color: v.primaryFocusedColor,
                background: v.primaryFocusedBackgroundColor,
            }
            : {
                color: color,
                background: v.focusedBackgroundColor,
            }));
};
var itemSeparator = function (_a) {
    var props = _a.props, v = _a.variables;
    var iconOnly = props.iconOnly, pointing = props.pointing, pills = props.pills, primary = props.primary, underlined = props.underlined, vertical = props.vertical;
    return (!pills &&
        !underlined &&
        !(pointing && vertical) &&
        !iconOnly && {
        '::before': __assign({ position: 'absolute', content: '""', top: 0, right: 0 }, (vertical ? { width: '100%', height: '1px' } : { width: '1px', height: '100%' }), (primary ? { background: v.primaryBorderColor } : { background: v.borderColor })),
    });
};
var pointingBeak = function (_a) {
    var props = _a.props, v = _a.variables;
    var pointing = props.pointing, primary = props.primary;
    var backgroundColor;
    var borderColor;
    var top;
    var borders;
    if (primary) {
        backgroundColor = v.primaryActiveBackgroundColor;
        borderColor = v.primaryBorderColor;
    }
    else {
        backgroundColor = v.activeBackgroundColor;
        borderColor = v.borderColor;
    }
    if (pointing === 'start') {
        borders = {
            borderTop: "1px solid " + borderColor,
            borderLeft: "1px solid " + borderColor,
        };
        top = '-1px'; // 1px for the border
    }
    else {
        borders = {
            borderBottom: "1px solid " + borderColor,
            borderRight: "1px solid " + borderColor,
        };
        top = '100%';
    }
    return {
        '::after': __assign({ visibility: 'visible', background: backgroundColor, position: 'absolute', content: '""', top: top, left: '50%', transform: 'translateX(-50%) translateY(-50%) rotate(45deg)', margin: '.5px 0 0', width: pxToRem(10), height: pxToRem(10), border: 'none' }, borders, { zIndex: 2, transition: 'background .1s ease' }),
    };
};
var menuItemStyles = {
    wrapper: function (_a) {
        var props = _a.props, v = _a.variables, theme = _a.theme;
        var active = props.active, iconOnly = props.iconOnly, isFromKeyboard = props.isFromKeyboard, pills = props.pills, pointing = props.pointing, secondary = props.secondary, underlined = props.underlined, vertical = props.vertical;
        return __assign({ color: v.color, background: v.backgroundColor, lineHeight: 1, position: 'relative', verticalAlign: 'middle', display: 'block' }, (secondary && {
            background: 'salmon',
        }), (pills && __assign({}, (vertical ? { margin: "0 0 " + pxToRem(5) + " 0" } : { margin: "0 " + pxToRem(8) + " 0 0" }), { borderRadius: pxToRem(5) })), (underlined && {
            display: 'flex',
            alignItems: 'center',
            height: pxToRem(29),
            lineHeight: v.lineHeightBase,
            padding: "0 " + pxToRem(4),
            margin: "0 " + pxToRem(4) + " 0 0",
            ':nth-child(n+2)': {
                marginLeft: "" + pxToRem(4),
            },
            boxShadow: 'none',
        }), (pointing &&
            vertical && __assign({ borderTopLeftRadius: "" + pxToRem(3), borderTopRightRadius: "" + pxToRem(3) }, (pointing === 'end'
            ? { borderRight: pxToRem(3) + " solid transparent" }
            : { borderLeft: pxToRem(3) + " solid transparent" }), { marginBottom: "" + pxToRem(12) })), (iconOnly && {
            display: 'flex',
        }), itemSeparator({ props: props, variables: v, theme: theme }), (active && __assign({}, getActionStyles({ props: props, variables: v, color: v.color }), (pointing &&
            (vertical
                ? pointing === 'end'
                    ? { borderRight: pxToRem(3) + " solid " + v.primaryActiveBorderColor }
                    : { borderLeft: pxToRem(3) + " solid " + v.primaryActiveBorderColor }
                : pointingBeak({ props: props, variables: v, theme: theme }))))), (isFromKeyboard && getFocusedStyles({ props: props, variables: v, color: v.activeColor })), { 
            // hover styles
            ':hover': getFocusedStyles({ props: props, variables: v, color: v.activeColor }), ':first-child': __assign({}, (!pills &&
                !iconOnly &&
                !(pointing && vertical) &&
                !underlined && __assign({}, (vertical && {
                borderTopRightRadius: pxToRem(3),
                borderTopLeftRadius: pxToRem(3),
                '::before': {
                    display: 'none',
                },
            }), (!vertical && {
                borderBottomLeftRadius: pxToRem(3),
                borderTopLeftRadius: pxToRem(3),
            })))), ':last-child': __assign({}, (!pills &&
                !iconOnly &&
                !(pointing && vertical) &&
                !underlined && __assign({}, (vertical && {
                borderBottomRightRadius: pxToRem(3),
                borderBottomLeftRadius: pxToRem(3),
            })))) });
    },
    root: function (_a) {
        var props = _a.props, v = _a.variables, theme = _a.theme;
        var active = props.active, iconOnly = props.iconOnly, isFromKeyboard = props.isFromKeyboard, pointing = props.pointing, primary = props.primary, underlined = props.underlined, vertical = props.vertical;
        var _b = theme.siteVariables, arrowDown = _b.arrowDown, arrowRight = _b.arrowRight;
        return __assign({ color: 'inherit', display: 'block', cursor: 'pointer' }, (((pointing && vertical) || iconOnly) && { border: '1px solid transparent' }), (underlined
            ? { padding: pxToRem(4) + " 0" }
            : pointing && vertical
                ? { padding: pxToRem(8) + " " + pxToRem(18) }
                : { padding: pxToRem(14) + " " + pxToRem(18) }), (iconOnly && {
            padding: pxToRem(8),
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }), (active &&
            (primary
                ? __assign({}, (iconOnly && { color: v.primaryActiveBorderColor }), (underlined && __assign({ color: v.primaryActiveBorderColor }, underlinedItem(v.primaryActiveBorderColor)))) : underlined && __assign({ fontWeight: 700 }, underlinedItem(v.activeColor)))), (isFromKeyboard && __assign({}, (primary
            ? __assign({}, (iconOnly && {
                color: v.primaryActiveBorderColor,
                border: "1px solid " + v.primaryActiveBorderColor,
                borderRadius: v.circularRadius,
            }), (underlined && { color: v.primaryActiveColor }), (underlined && active && underlinedItem(v.primaryActiveColor))) : __assign({}, (iconOnly && {
            border: "1px solid " + v.activeColor,
            borderRadius: v.circularRadius,
        }), (underlined && { fontWeight: 700 }), (underlined && active && underlinedItem(v.activeColor)))))), { ':focus': {
                outline: 0,
            }, 
            // hover styles
            ':hover': __assign({ color: 'inherit' }, (primary
                ? __assign({}, (iconOnly && { color: v.primaryActiveBorderColor }), (!active && underlined && underlinedItem(v.primaryHoverBorderColor))) : !active && underlined && underlinedItem(v.activeBackgroundColor))), '::after': __assign({}, (props.menu && {
                position: 'relative',
                float: 'right',
                left: pxToRem(10),
                userSelect: 'none',
                content: props.vertical ? "\"" + arrowRight + "\"" : "\"" + arrowDown + "\"",
            })) });
    },
    menu: function (_a) {
        var vertical = _a.props.vertical;
        return ({
            zIndex: '1000',
            position: 'absolute',
            top: vertical ? '0' : '100%',
            left: vertical ? '100%' : '0',
        });
    },
};
export default menuItemStyles;
